import { render, staticRenderFns } from "./GroupChatPhotosReveals.vue?vue&type=template&id=2f3276b9&"
import script from "./GroupChatPhotosReveals.vue?vue&type=script&lang=js&"
export * from "./GroupChatPhotosReveals.vue?vue&type=script&lang=js&"
import style0 from "./GroupChatPhotosReveals.vue?vue&type=style&index=0&id=2f3276b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports